import React, { useEffect, useState, useCallback } from 'react'
import { CSmartTable, CAccordionBody } from '@coreui/react-pro'
import UserService from 'src/service/UserService'

const MctGameAccord6 = ({ isOpen }) => {
  const [loading, setLoading] = useState(false)
  const [activePage, setActivePage] = useState(1)
  const [columnFilter, setColumnFilter] = useState({})
  const [columnSorter, setColumnSorter] = useState(null)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [users, setUsers] = useState()
  const columns = [
    { label: 'Game ID', key: 'id' },
    { key: 'game_name', label: 'Game Name' },
    { label: 'Hub Name', key: 'hub_name' },
    { label: 'Hub ID', key: 'hub_id' },
    { label: 'Game Pass', key: 'collect_game_pass' },
    { label: 'Collection Method', key: 'collect_game_pass_method' },
    { label: 'Collection Required', key: 'collect_game_pass_required' },
  ]

  // Wrap fetchGameData in useCallback to manage dependencies

  const fetchGameDataForAccord6 = useCallback(async () => {
    setLoading(true)
    try {
      const offset = (activePage - 1) * itemsPerPage
      const params = new URLSearchParams()
      Object.keys(columnFilter).forEach((key) => params.append(key, columnFilter[key]))
      if (columnSorter?.column)
        params.append('sort', `${columnSorter.column}%${columnSorter.state}`)

      const result = await UserService.getMctGameAccord4Listing(
        offset,
        itemsPerPage,
        activePage,
        params,
      )
      setUsers(result.data)
    } catch (error) {
      console.error('Error fetching game data:', error)
    } finally {
      setLoading(false)
    }
  }, [activePage, columnFilter, columnSorter, itemsPerPage]) // Add dependencies for re-running

  useEffect(() => {
    if (isOpen) {
      console.log('from useEffect')
      fetchGameDataForAccord6()
    }
  }, [isOpen, fetchGameDataForAccord6])

  return (
    <>
      <CAccordionBody>
        <CSmartTable
          columns={columns}
          columnFilter={{ external: true }}
          columnSorter={{ external: true }}
          scopedColumns={{
            collect_game_pass: (item) => (
              <td> {item?.collect_game_pass == 0 ? 'Free' : 'Collection Method Applied'}</td>
            ),
            collect_game_pass_method: (item) => (
              <td>
                {' '}
                {item?.collect_game_pass === 1
                  ? 'MCT'
                  : item?.collect_game_pass === 2
                  ? 'Self'
                  : null}
              </td>
            ),
            collect_game_pass_required: (item) => (
              <td> {item?.collect_game_pass == 1 ? 'Yes' : 'No'}</td>
            ),
          }}
          items={users?.data}
          itemsPerPage={itemsPerPage}
          itemsPerPageSelect
          loading={loading}
          pagination={{ external: true }}
          paginationProps={{
            activePage,
            pages: Math.ceil(users?.total / itemsPerPage) || 1,
          }}
          tableProps={{ hover: true, responsive: true }}
          onActivePageChange={setActivePage}
          onColumnFilterChange={(filter) => {
            setActivePage(1)
            setColumnFilter(filter)
          }}
          onItemsPerPageChange={(itemsPerPage) => {
            setActivePage(1)
            setItemsPerPage(itemsPerPage)
          }}
          onSorterChange={setColumnSorter}
        />
      </CAccordionBody>
    </>
  )
}

export default MctGameAccord6
